import colors from "../../theme/colors";

/**
 * Layout tokens for the public (unauthenticated) forms — the loan application
 * and the credit authorization.
 *
 * These are the only surfaces in the app that render outside
 * AuthenticatedDashboard's chrome, so they need their own canvas/rail geometry.
 * The COLORS still come from theme/colors so a white-labelled partner doesn't
 * end up with a form in someone else's palette; only the brand accent is left to
 * the MUI theme (`primary.main`), which is where the per-partner color lands.
 */
export const APP_TOKENS = {
  canvas: colors.slate50,
  border: colors.slate200,
  // A step darker than `border` — for control outlines, which need to read as
  // interactive against the section dividers using `border`.
  borderStrong: colors.slate300,
  headerTint: colors.slate50,
  ink: colors.slate900,
  inkMuted: colors.slate500,
  inkFaint: colors.slate400,
  surface: colors.white,
  radius: "12px",
  railWidth: "300px",
  contentMaxWidth: "880px",
};

/**
 * Field metrics for the public forms, matched to the LOS application form so a
 * borrower sees the same form in either place.
 *
 * Spread onto the step card by PublicFormShell rather than baked into
 * RffInputWrapper: these numbers are the LOS's, and the broker-facing screens in
 * this app use the denser dashboard label style. Scoping keeps both.
 *
 * The values come from the LOS's InputWrapper + its MuiInputLabel theme
 * override: 0.84375rem / weight 400 / slate500, sitting 3px above the control.
 */
export {
  FORM_FIELD_SX as PUBLIC_FORM_FIELD_SX,
  FORM_GRID_COLUMN_GAP as PUBLIC_FORM_GRID_COLUMN_GAP,
  FORM_GRID_ROW_GAP as PUBLIC_FORM_GRID_ROW_GAP,
} from "../../theme/formCardStyles";

/**
 * Indent + left-rule treatment for a group of follow-up questions that only
 * exist because of the answer directly above them.
 */
export const dependentGroupStyles = {
  ml: 1,
  pl: 3,
  pt: 2,
  pb: 1,
  mt: -1,
  borderLeft: "2px solid",
  borderColor: "primary.main",
};
